import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { type CreditCoverage, parseCreditCoverage } from "../../supabase/functions/_shared/credits-coverage";

export function useCreditCoverage(orgId: string | null, enabled: boolean, refreshKey?: unknown) {
  const [result, setResult] = useState<{ orgId: string; coverage: CreditCoverage } | null>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!orgId || !enabled) return;
    let cancelled = false;
    Promise.resolve(supabase.rpc("current_credit_coverage" as never)).then(({ data, error }) => {
      if (cancelled) return;
      if (error) console.error("[useCreditCoverage]", error.message);
      const row = !error && data && typeof data === "object" ? (data as Record<string, unknown>) : null;
      const sameOrg = row?.organization_id === orgId;
      setResult({ orgId, coverage: parseCreditCoverage(sameOrg ? row : null) });
    });
    return () => { cancelled = true; };
  }, [orgId, enabled, version, refreshKey]);

  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  const loaded = !!orgId && result?.orgId === orgId;

  return {
    coverage: enabled && loaded ? result.coverage : null,
    loading: enabled && !!orgId && !loaded,
    refresh,
  };
}
